<template>
  <component 
    :is="href ? 'a' : 'div'"
    :href="href"
    class="blurb-card rounded-md shadow-lg p-8 bg-Neutral-50 flex-1 text-black hover:bg-Primary-50"
  >
    <div class="rounded-xl p-8 bg-white img-container">
      <img class="mx-auto" :src="image" />
    </div>
    <h3 class="text-3xl mt-8 leading-8">{{ heading }}</h3>
    <p class="text-xl mt-4 leading-6">{{ desc }}</p>
  </component>
</template>
<script setup>
const props = defineProps({
  heading: {
    type: String,
    required: true,
  },
  desc: {
    type: String,
  },
  image: {
    type: String
  },
  href: {
    type: String
  }
});
</script>
<style scoped>
.blurb-card:hover {
  .img-container {
    @apply bg-white;
  }
}
</style>